import React, {useEffect, useMemo, useRef, useState} from 'react';
import { v4 as uuid } from 'uuid'
import { addItem } from './Tree/utilities.ts';
import { TreeItem, TreeItems } from './Tree/types.ts';
import './Tree/SortableTree.css';

function MyButton(  {items,
                     setItems,
                     specifiedCreatedTaskOwnerId,
                     primaryLabel = 'None',
                     status = 'New',
                     goal = false}  ) {

    const [inputStartText, setInputStartText] = useState('');

    function handleClick(e) { 

      e.preventDefault();

      // Read the form data
      const form = e.target;
      const formData = new FormData(form);

      // Or you can work with it as a plain object:
      const formJson = Object.fromEntries(formData.entries());

      setInputStartText('');

      const cumulativeItemCount = parseInt(localStorage.getItem("itemCount"));
      let cumulativeItemCountString;
      console.log('Cumulative item count as parsed: '+cumulativeItemCount);
      if(isNaN(cumulativeItemCount)) {
        cumulativeItemCountString = "0";
      }
      else {
      cumulativeItemCountString = cumulativeItemCount;
      }

      if(items) {

        let newTaskTitle;

        newTaskTitle = goal ? formJson.goalTitle : formJson.taskTitle;
        
        let newItem;

        newItem = [{id: uuid(), 
                    title: "Task #" + cumulativeItemCountString + " : " + newTaskTitle,
                    ownerId: specifiedCreatedTaskOwnerId,
                    creationDate: new Date((new Date(Date.now())).toUTCString()),
                    children: [], 
                    goal: goal, 
                    status: status, 
                    primaryLabel: primaryLabel}];
      
        const newItems = newItem.concat(items);
        setItems(newItems);
      
        const dbOpenRequest = window.indexedDB.open("TasksDB",1);

        let db;

        let objectStore;

        dbOpenRequest.onerror = (event) => {
          console.error(`Database error: ${event.target.error?.message}`);
          alert("Issue connecting to DB!!");
        };

        dbOpenRequest.onsuccess = (event) => {
          db = event.target.result;
          console.log('DB connection opened for updating!!');

        // This assumes the objectStore has already been successfully created in the DB
        // TODO: handle the exception if not.
        const objectStore = db
          .transaction("TaskNestedLists", "readwrite")
          .objectStore("TaskNestedLists");
          
          console.log('Got object store on button clicked!! '+ objectStore);
          const storedItems = event.target.result;
          console.log('Items obtained from DB: '+storedItems);
          const requestUpdate = objectStore.put(newItems,1);
          requestUpdate.onsuccess = (event) => {
            // Success - the data is updated! Update the task count
            localStorage.setItem("itemCount", cumulativeItemCountString+1);
          };

        };

        dbOpenRequest.onupgradeneeded = (event) => {
          db = event.target.result;
          alert("DB was upgraded!!");  
          
          const objectStore = db
          .transaction("TaskNestedLists", "readwrite")
          .objectStore("TaskNestedLists");

          objectStore.put(newItems, 1);

        };

      }
    
    };

  return(
    <form method="post" onSubmit={handleClick}>
      {goal && (
        <label className="App-Labels">New Goal Title:  
            <input name="goalTitle" 
                  value={inputStartText} 
                  onChange={e => setInputStartText(e.target.value)} 
                  placeholder="Enter a new goal name here..."
                  size="75"
                  type='text'
                  // autoFocus
            />
            <button type="submit">Create Goal</button>
        </label>
      )}
      {!goal && (
        <label className="App-Labels">New Task Title:  
          <input name="taskTitle" 
                value={inputStartText} 
                onChange={e => setInputStartText(e.target.value)} 
                placeholder="Enter a new task here..."
                size="75"
                type='text'
                // autoFocus
          />
          <button type="submit">Create Task</button>
        </label>
      )}
    </form>
  );

}

export default MyButton;